import React from "react";
import styled from "styled-components";
import { Formik } from "formik";
import { Button, Spinner } from "components/generic/kit";
import { Radio } from "components/generic/form/formik";
import Stripe from "../Stripe";

export default ({
  cost,
  promo_code,
  isCheckingOut,
  isFormVisible,
  showForm,
  hideForm,
  cards,
  initialValues,
  onGetToken,
  checkoutApi,
  deleteCard,
  deletingCardId,
  onSubmit
}) => (
  <Formik initialValues={initialValues} onSubmit={onSubmit}>
    {({ handleSubmit, values }) => (
      <div>
        <div className="mt3 mb3 ph0-ns ph3">
          {cards.map((card, i) => (
            <CardWrap className="flex justify-between items-center" key={i}>
              <Radio
                disabled={deletingCardId === card.id}
                name="card"
                value={card.id + ""}
                title={
                  <div className="ml2 flex items-center ">
                    <CardImg type={card.brand} className="mr2" />
                    <div className="flex flex-column">
                      <div> {card.brand}</div>
                      <div>ending in {card.expiry_year}</div>
                    </div>
                  </div>
                }
              />
              <div
                className="pointer gray"
                onClick={e => {
                  e.preventDefault();
                  if (isFormVisible) {
                    hideForm();
                  } else {
                    showForm();
                  }
                }}
              >
                Change
              </div>
              {deletingCardId === card.id && (
                <div className="ml1 mb2">
                  <Spinner size="2" />
                </div>
              )}
            </CardWrap>
          ))}
        </div>
        {isFormVisible && (
          <div className="mt2">
            <Stripe onGetToken={onGetToken} completeText="Create card" />
          </div>
        )}
        {cost}
        {promo_code}
        <form onSubmit={handleSubmit}>
          <div className="mt3">
            {!checkoutApi.isFetching ? (
              <Button size="small" color="white" finalize>
                FINALIZE BOOKING
              </Button>
            ) : (
              "Processing a payment..."
            )}
          </div>
        </form>
      </div>
    )}
  </Formik>
);

const Remove = styled.div``;

const CardWrap = styled.div`
  font-family: CircularStd-Book, sans-serif;
  font-size: 16px;
  &:hover ${Remove} {
    display: block;
  }
`;

const CardImg = styled.img`
  background-image: ${({ type }) => `url('/assets/cards/${type}.svg')`};
  background-size: contain;
  padding: 20px 32px;
  background-repeat: no-repeat;
  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.2);
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Payment/components/Cards/View.js